/**
 * IncomeTabs — shared tab bar for the merged income-planning surfaces.
 * Projection (multi-year) / Monthly (next 12) / Dividends.
 */
import { useLocation } from 'react-router-dom'

const TABS: Array<{ href: string; label: string }> = [
  { href: '/app/income', label: 'Overview' },
  { href: '/app/income-projection', label: 'Projection' },
  { href: '/app/monthly-income', label: 'Monthly' },
  { href: '/app/dividends', label: 'Dividends' },
]

export default function IncomeTabs() {
  const location = useLocation()
  const current = location.pathname

  return (
    <div className="flex items-center gap-1 border-b border-border flex-wrap">
      {TABS.map(t => {
        const active = current === t.href
        return (
          <a
            key={t.href}
            href={t.href}
            className={
              active
                ? 'px-4 py-2.5 text-sm font-medium border-b-2 border-emerald-400 text-emerald-400 -mb-px'
                : 'px-4 py-2.5 text-sm font-medium text-text-muted hover:text-text-secondary border-b-2 border-transparent -mb-px'
            }
          >
            {t.label}
          </a>
        )
      })}
    </div>
  )
}
